/* Opção hero carousel: arrow buttons, edge states and optional autoplay for [data-olh-carousel]. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (!root || root.dataset.olhReady) return;
    root.dataset.olhReady = 'true';

    const rail = root.querySelector('[data-olh-rail]');
    const prev = root.querySelector('[data-olh-prev]');
    const next = root.querySelector('[data-olh-next]');
    if (!rail) return;

    const step = () => {
      const card = rail.querySelector('[data-olh-card]');
      if (!card) return rail.clientWidth;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    const atStart = () => rail.scrollLeft <= 4;
    const atEnd = () => rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    const behavior = () => (reduceMotion.matches ? 'auto' : 'smooth');

    const update = () => {
      if (prev) prev.disabled = atStart();
      if (next) next.disabled = atEnd();
    };

    prev?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: behavior() }));
    next?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: behavior() }));
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    const delay = parseInt(root.dataset.olhAutoplay, 10);
    if (!delay || reduceMotion.matches) return;

    let timer = null;
    let paused = false;
    const tick = () => {
      if (paused || document.hidden) return;
      if (atEnd()) rail.scrollTo({ left: 0, behavior: behavior() });
      else rail.scrollBy({ left: step(), behavior: behavior() });
    };
    const start = () => { if (!timer) timer = setInterval(tick, delay * 1000); };
    const pause = () => { paused = true; };
    const resume = () => { paused = false; };

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    rail.addEventListener('touchstart', pause, { passive: true });
    rail.addEventListener('touchend', () => setTimeout(resume, 4000), { passive: true });
    start();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-olh-carousel]').forEach(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
